export const CHECK_LOGIN = 'check_login';
export const LOGIN_USER_SUCCESSFUL = 'login_user_successfull';

export const LOGOUT_USER = 'LOGOUT_USER';
export const LOGOUT_USER_SUCCESS = 'LOGOUT_USER_SUCCESS';

export const UPDATE_USER_ROLE = 'UPDATE_USER_ROLE';
export const UPDATE_USER_ROLE_SUCCESS = 'UPDATE_USER_ROLE_SUCCESS';

export const SIGNUP_INIT = 'signup_init';
export const SIGNUP_USER = 'signup_user';
export const SIGNUP_USER_SUCCESS = 'signup_user_success';

export const API_ERROR = 'api_failed';

export const GET_ALLOWED_ACTIONS = 'GET_ALLOWED_ACTIONS';
export const SET_ALLOWED_ACTIONS = 'SET_ALLOWED_ACTIONS';
